module.exports = new __parcel__URL__("shop_buy_swap_button.1cbea2d4.png").toString();